import { gql } from '@apollo/client';
import { FUNDER } from '../fragments';

export const ALL_FUNDERS = gql`
  query AllFunders {
    funders: allFunders {
      ...funder
    }
  }
  ${FUNDER}
`;
